import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicProtectionData = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Conditions juridiques', link: '/topics/about/juridiques'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Cet article est en cours de rédaction... ChatGpT etait en panne :p
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Commençons ! Le plus simple et le plus rapide est de<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>contacter</a>.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicProtectionData